_ = require('lodash')
moment = require('moment')

RegistrationService = ($http, $q, CountryService, PrefectureService, GenderService, TermService) ->
  formatBirthDay = (date) ->
    date.format 'YYYY-MM-DD'

  create_email: (email) ->
    data = _.merge {},
      email: email,
      accepted_term_version: TermService.getAcceptedTermVersion()
    $http.post 'api/registrations/user/email.json', data

  check_token: (token) ->
    data = _.merge {},
      token: token,
    $http.post 'api/registrations/user/email/token.json', data

  create: (account) ->
    data = _.merge {}, account,
      birthday: formatBirthDay(account.birthday),
      accepted_term_version: TermService.getAcceptedTermVersion()
    $http.post 'api/registrations/user/email/create.json', data

  # TODO create test
  get: ->
    delay = $q.defer()
    $http.get('/api/settings/account.json').then (resp) ->
      delay.resolve resp.data
    .catch (resp) ->
      delay.reject 'auth error'
    delay.promise

  # TODO create test
  update: (account) ->
    data = _.merge {}, account, birthday: formatBirthDay(account.birthday)
    $http.put '/api/settings/account.json', data

  getDefaultData: ->
    countries: CountryService.get()
    prefectures: PrefectureService.get()
    genders: GenderService.get()

  getTokenFormEmail: ->
    localStorage.getItem 'tokenFormEmail'

  setTokenFormEmail: (email) ->
    localStorage.setItem "tokenFormEmail", email

  clearAcceptLocal: ->
    localStorage.removeItem 'tokenFormEmail'


RegistrationService.$inject = [
  '$http'
  '$q'
  'CountryService'
  'PrefectureService'
  'GenderService'
  'TermService'
]

module.exports = RegistrationService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/registration-service.coffee